import React, { Component } from 'react';
import '../../../styles/global.scss';
import MonthlyUnitLineChart from "./monthly-unit-line-chart";
import {ChartColors} from "../constants/chart-color-constants";
import {from} from "linq";
import moment from "moment";

class MonthlyEventTypeChart extends Component {
    constructor(props) {
        super(props);


     
        const collatedData = this.collateEventTypeData(props.data);
        const units = this.generateUnits(props.data);

       

        this.state = {
            units: units,
            collatedData: collatedData
        }
    }

    generateUnits(cases) {
        const colors = [ChartColors.a, ChartColors.b, ChartColors.c, ChartColors.d, ChartColors.e, ChartColors.f, ChartColors.g];
        let index = 0;
        return from(cases)
            .select(x => x.eventType)
            .distinct()
            .select(x => {
                if(index >= colors.length) { index = 0; }
                return { field: x, label: x, color: colors[index++] }
            }).toArray();

    }

    collateEventTypeData(cases) {



        return from(cases)
            .orderByDescending(x => x.dateLogged)
            .select(x => {
               
                const data = moment(x.dateLogged, 'YYYY-MM-DDThh:mm:ss').startOf("month").format("DD/MM/YYYY HH:mm:ss");
                //Write me a filter here
                return { date: data, eventType: x.eventType };

            })
            .groupBy(x => x.date, null, (key, group) => {
                const result = { date: key };
                group.groupBy(y => y.eventType, null, (eventKey, eventGroup) => {
                    result[eventKey] = eventGroup.count();
                }).toArray();
                return result;
            })
           
            .orderBy(x => moment(x.date, 'DD/MM/YYYY HH:mm:ss'))
            .toArray();
    }

  

    render() {
        return (
            <MonthlyUnitLineChart data={this.state.collatedData} units={this.state.units} title={this.props.title} 
            onElementsClick={this.props.onElementsClick} // Pass the callback function here
            label={this.props.label} />
        )
    }
}

export default MonthlyEventTypeChart;